// extracted by mini-css-extract-plugin
export default {"cardWrapper":"Thankyou_cardWrapper__UTzBJ","innerCardWrapper":"Thankyou_innerCardWrapper__a7CaC","btn":"Thankyou_btn__k7zs+","cardBody":"Thankyou_cardBody__IxCJt"};